import { STORE_RECONCILIATION_STATUS } from "../../constants/status";

export const STATUS_OPTIONS = [
  { value: STORE_RECONCILIATION_STATUS.ABERTO, label: "Aberto" },
  { value: STORE_RECONCILIATION_STATUS.AGUARDANDO, label: "Aguardando" },
  { value: STORE_RECONCILIATION_STATUS.FECHADO, label: "Fechado" },
];
